<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">App更新管理</div>
          <span class="m-title-s">对App更新进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>App更新列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增更新</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="note" label="更新内容"></el-table-column>
          <el-table-column prop="version" label="版本" width="80" align="center"></el-table-column>
          <el-table-column prop="force" label="是否重要" align="center" width="80">
            <template slot-scope="scope">
              <span v-text="scope.row.force === '1' ? '重要' : '次要'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="上传更新包：">
              <el-row>
                <el-col :span="7">
                  <el-upload
                    :action="'package/app/'"
                    :before-upload="fnBeforeUpload"
                    :on-success="success"
                    :on-remove="handleAudioRemove"
                    :http-request="fnUploadRequest"
                    accept=".apk"
                    :limit="1">
                    <el-button size="small" type="primary">上传安装包</el-button>
                    <div slot="tip" class="el-upload__tip">上传文件大小不能超过 100M</div>
                  </el-upload>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="更新说明: " prop="note">
              <el-input v-model="form.note" placeholder="输入更新说明"></el-input>
            </el-form-item>
            <el-form-item label="更新版本: " prop="version">
              <el-input v-model="form.version" placeholder="输入更新版本"></el-input>
            </el-form-item>
            <el-form-item label="更新链接: " prop="url">
              <el-input v-model="form.url" placeholder="输入更新链接"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="重要" inactive-text="次要"></el-switch>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'appRenewManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      currentPage: 1,
      total: 0,
      accessKeys: {
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        region: ''
      },
      searchForm: {
        pageNo: 1
      },
      form: {
        id: '',
        url: '',
        version: '',
        note: '',
        force: '1', // 1 重要 0 不重要
        remarks: ''
      },
      rules: {
        note: [
          { required: true, message: '请输入更新说名', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入更新版本', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入更新链接', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 图片上传成功
    success (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.icon = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.dialogImageUrl = this.$httpConf.ossURL + file.response.data
        this.$message.success('上传成功')
      }
    },
    // 删除上传文件时执行
    handleAudioRemove (file, fileList) {
    },
    // 限制上传文件大小
    fnBeforeUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 100MB!')
      }
      return isLt2M
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     */
    async fnUploadRequest (option) {
      if (this.accessKeys.accessKeyId === '') {
        return this.$message.error('未获取到ossKey,请刷新页面重试')
      }
      try {
        let vm = this
        vm.disabled = true
        let oss = require('ali-oss')
        let client = oss({
          accessKeyId: vm.accessKeys.accessKeyId,
          accessKeySecret: vm.accessKeys.accessKeySecret,
          bucket: vm.accessKeys.bucket,
          region: vm.accessKeys.region,
          success_action_status: '200'
        })
        let file = option.file
        // 获取文件后缀
        const point = file.name.lastIndexOf('.')
        let suffix = file.name.substr(point)
        let fileName = file.name.substr(0, point)

        // 拼接文件名称
        let fileNames = `${fileName}_${new Date().getTime()}${suffix}`
        // 分片上传文件
        let ret = await client.multipartUpload(option.action + fileNames, file, {
          progress: async function (p) {
            let e = {}
            e.percent = p * 100
            option.onProgress(e)
          }
        })
        if (ret.res.status === 200) {
          return ret
        } else {
          option.onError('上传失败')
        }
      } catch (error) {
        option.onError('上传失败')
        this.$message.error(error.message)
      }
    },
    handleCurrentChange (val) {
      this.listData(val)
    },
    closeDialog: function () {
      this.form = {
        id: '',
        url: '',
        version: '',
        note: '',
        force: '1', // 1 重要 0 不重要
        remarks: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          _this.form.force = _this.isStatus === true ? '1' : '0'
          let url = _this.form.id === '' ? '/admin/renewAdd' : '/admin/renewEdit'
          this.$axios.post(url, _this.form)
            .then((res) => {
              if (res.code === 200) {
                _this.$message({
                  message: res.msg,
                  type: 'success',
                  center: true,
                  onClose: function () {
                    _this.listData(_this.currentPage)
                    _this.openState = false
                    _this.formLoading = false
                  }
                })
              } else {
                _this.$message({
                  message: res.msg,
                  type: 'error',
                  center: true,
                  onClose: function () {
                    _this.formLoading = false
                  }
                })
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/admin/renewDel', {id: id})
          .then((res) => {
            if (res.code === 200) {
              _this.$message({
                type: 'success',
                duration: '800',
                message: res.msg,
                onClose: function () {
                  _this.listData(_this.currentPage)
                }
              })
            } else {
              _this.$message({
                type: 'error',
                duration: '800',
                message: res.msg
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    openForm (opt) {
      let _this = this
      this.openText = '编辑'
      _this.form = opt
      _this.isStatus = _this.form.force === '1'
      _this.openState = true
    },
    // 列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/sys/appRenew/list', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 获取ossKey
    getUploadKey () {
      let _this = this
      this.isLoading = true
      this.$axios.post('/article/getUploadKey')
        .then((res) => {
          if (res.status === 200) {
            _this.accessKeys = res.data
          }
        })
    }
  },
  mounted () {
    this.listData()
    this.getUploadKey()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/AppRenewManage.vue